const blueA = {
  blueA1: "hsla(210, 100%, 51.0%, 0.016)",
  blueA2: "hsla(210, 100%, 51.0%, 0.040)",
  blueA3: "hsla(210, 100%, 50.3%, 0.071)",
  blueA4: "hsla(210, 100%, 50.1%, 0.118)",
  blueA5: "hsla(208, 99.1%, 47.1%, 0.189)",
  blueA6: "hsla(209, 99.5%, 45.3%, 0.283)",
  blueA7: "hsla(208, 99.9%, 43.8%, 0.412)",
  blueA8: "hsla(206, 99.8%, 45.1%, 0.632)",
  blueA9: "hsla(206, 100%, 50.0%, 0.980)",
  blueA10: "hsla(208, 100%, 47.2%, 0.980)",
  blueA11: "hsla(212, 100%, 43.0%, 0.980)",
  blueA12: "hsla(213, 100%, 14.4%, 0.980)"
};
export { blueA };
//# sourceMappingURL=blueA.mjs.map
